export const PRICING_TABLE = 'pricing-table'
export const PRICING_TABLE_HEADER = 'pricing-table-header'
